import { useEffect } from 'react';
import useMap from '@alltrails/maps/hooks/useMap';
import { useAppDispatch } from '@/utils/redux';
import { setReturningBounds } from '@/utils/slices/exploreSlice';

/**
 * Stores the current map bounds in Redux before entering a focus state (trail, POI, park).
 * These bounds are used by `useReturnToExploreRoot` to restore the map position when navigating back.
 */
const useStoreReturningBounds = () => {
  const map = useMap();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (map) {
      const mapBounds = map.getBounds();
      if (mapBounds) {
        dispatch(
          setReturningBounds({
            longitudeBottomRight: mapBounds._ne.lng,
            latitudeBottomRight: mapBounds._sw.lat,
            longitudeTopLeft: mapBounds._sw.lng,
            latitudeTopLeft: mapBounds._ne.lat
          })
        );
      }
    }
  }, [dispatch, map]);
};

export default useStoreReturningBounds;
